import React from "react";
import { Link } from "react-router-dom";

import "./style.scss";

const Index = () => {
  return (
    <section className="article-section privacy">
      <div className="inner-article-container">
        <div className="snippet-container">
          <h1 className="article-title">Personvern</h1>
          <p className="article-text">
            Leadfind AS (“oss”, “vi” eller “vår”) driver nettstedet
            www.leadfind.no (“tjenesten”). Vi er opptatt av at du skal ha tillit
            til oss og hvordan vi behandler dine personopplysninger. I denne
            personvernerklæringen forklarer vi derfor hvorfor vi samler inn
            informasjon om deg, hvordan vi bruker denne informasjonen og hvordan
            vi tar hensyn til ditt personvern.
            <br />
            <br />
            Personopplysninger er opplysninger og vurderinger som kan knyttes
            til en identifiserbar enkeltperson. Dette kan for eksempel være navn
            og kontaktinformasjon, kjøpshistorikk eller informasjon om
            interesser. <br />
            <br />
            Bruk av personopplysninger må følge personopplysningsloven. Vi, som
            behandlingsansvarlig, vil sørge for at vi bruker personopplysninger
            om deg i samsvar med lovens regler.
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">
            Hvilke personopplysninger har vi om deg
          </h3>
          <p className="article-text">
            Ved bruk av vår tjeneste ber vi deg ved registrering oppgi enkelte
            personopplysninger som kan brukes til å kontakte eller identifisere
            deg ("Personlig data"). Dette er følgende data vi lagrer fra deg:
          </p>
          <ol>
            <li>
              <span className="bold">Opplysninger om deg:</span> Informasjon du
              oppgir når du oppretter en konto, som fornavn, etternavn,
              telefonnummer og e-postadresse. Du kan velge å gi oss mer
              informasjon om deg selv, som adresse, postnummer, poststed og
              land.{" "}
            </li>
            <li>
              <span className="bold">Betalingsinformasjon:</span> Vi lagrer
              aldri kortinformasjon, men kun detaljer rundt kjøpet av abonnement
              som er tilgjengelig gjennom Stripe (customer id, session id,
              subscription id og timestamp) som fungerer som et trygt mellomledd
              og som sørger for at detaljer rundt betalingen din alltid vil være
              trygt lagret hos dem.
            </li>
            <li>
              <span className="bold">Kommunikasjon:</span> Informasjon du gir
              oss når du har kontakt med vårt kundesenter, som e-poster sendt
              til og fra hverandre eller dialog som gjøres gjennom vår live-chat
              widget.
            </li>
            <li>
              <span className="bold">Opplysninger om bruk på nettsidene:</span>{" "}
              Data vi får når du bruker vår nettside og app, som hva slags enhet
              du benytter deg av (f.eks. mobil, nettbrett eller PC), siste
              aktivitet, IP-adresse og hvilke funksjonalitet du benytter deg av.
            </li>
            <li>
              <span className="bold">Profileringsopplysninger: </span>
              Informasjon og antakelser vi lager automatisk basert på de
              opplysningene (nevnt ovenfor) vi har om deg, som for eksempel
              interesser, preferanser og demografi, med mindre du ikke har gitt
              samtykke til dette.
            </li>
          </ol>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">
            Hva vi bruker personopplysningene dine til
          </h3>
          <p className="article-text">
            Vi bruker personopplysningene dine til følgende:
          </p>
          <ol>
            <li>
              <span className="bold">Nettside og tjeneste:</span> Vi bruker dine
              opplysninger for å tilpasse innholdet i vår tjeneste og nettside
              basert på hva slags utstyr du benytter deg av (PC, mobil eller
              nettbrett), og hva slags rolle, rettigheter og funksjonalitet du
              skal ha tilgang til på plattformen.
            </li>
            <li>
              <span className="bold">Registrering:</span> Siden Leadfind er en
              online tjeneste med mange forskjellige brukere er det behov for å
              verifisere identiteten din, og vi bruker denne informasjonen for å
              gi deg tilgang med e-postadresse og passord.
            </li>
            <li>
              <span className="bold">Kundeservice:</span> Vi lagrer
              meldingslogger fra e-poster som har blitt vekslet mellom oss, samt
              dialoger fra vår live-chat for å yte best mulig service og styrke
              kundeforholdet ytterligere.
            </li>
            <li>
              <span className="bold">Statistikk og monitorering:</span> I et
              forsøk på å hele tiden tilby deg den beste brukeropplevelsen
              benytter vi oss av tredjepartsløsninger for å holde oversikt over
              besøkende og se hvordan disse beveger seg på siden i et forsøk på
              å fange opp feil og gjøre forbedringer. Dette er data som ikke kan
              kobles direkte til deg som person, men bruker IP adresse som
              referanse.
            </li>
            <li>
              <span className="bold">Markedsføring</span> Vi bruker din
              kontaktinformasjon til å sende deg anbefalinger og nyheter
              angående vår tjeneste, med mindre du har motsatt deg dette.
            </li>
          </ol>
        </div>
        <div className="snippet-container">
          <h1 className="article-subtitle">
            Rettslig grunnlag for behandling av personopplysninger under
            Personvernforordningen GDPR (General Data Protection Regulation)
          </h1>
          <p className="article-text">
            Hvis du befinner deg innenfor Det europeiske økonomiske
            samarbeidsområde (EØS), har vi rettslig grunnlag for å samle inn og
            bruke disse opplsyningene som er beskrevet i denne
            personvernerklæringen. Vi kan samle inn og behandle dine personlige
            data fordi:
          </p>
          <ol>
            <li>Du må akseptere avtalen før registrering.</li>
            <li>Du samtykker til at vi kan samle inn dataen.</li>
            <li>Den overstyres ikke av dine rettigheter.</li>
            <li>For å overholde loven.</li>
          </ol>
        </div>
        <div className="snippet-container">
          <h1 className="article-subtitle">
            Hvem vi deler personopplysningene med
          </h1>
          <p className="article-text">
            Vi benytter oss av ulike tredjepartsleverandører for å forbedre
            tjenesten vår både i form av funksjonalitet og service. Disse
            tredjepartene har bare tilgang til dine personopplysninger for å
            utføre disse oppgavene på våre vegne og er samtidig forpliktet og
            lovpålagt å ikke offentliggjøre eller bruke denne dataen til noen
            andre formål. Vi benytter oss at IT-leverandører utenfor EØS, og
            dine personlige data er trygt lagret og kryptert til enhver tid.
          </p>
          <ol>
            <li>
              <span className="bold">Google Cloud Platform:</span> Dette er en
              paraply av tjenester som er drevet av Google og tilbyr en rekke
              tjenester som <a href="https://analytics.google.com/">analyse</a>{" "}
              og{" "}
              <a href="https://ads.google.com/intl/sv_NO/home/">
                markedsføring
              </a>
              . Dette bruker vi for å sørge for at vi kan skalere tjenesten på
              en god måte og samtidig få pålitelig data.
            </li>
            <li>
              <span className="bold">Facebook:</span> Vi deler også
              informasjonen med Facebook for å drive målrettet og effektiv
              markedsføring av plattformen vår. Dette for å sørge for at vi
              finnes på kanaler som er relevant for det vi driver med, og
              samtidig være der hvor andre i bransjen også befinner seg.
            </li>
            <li>
              <span className="bold">Hotjar:</span> Dette er et verktøy for å
              monitorere aktivitet på siden, og hjelper oss med å forstå
              brukeratferd og hvordan brukere tar i bruk siden vår. På denne
              måten kan vi enklere se på funksjonalitet som funker og ikke, slik
              at vi hele tiden kan optimalisere løsningen.
            </li>
            <li>
              <span className="bold">Stripe:</span> Betalingsløsningen vi
              benytter oss av for å gi brukeren mulighet til å starte, endre og
              avslutte abonnement på siden, samtidig som den hjelper oss med å
              få oversikt og kontrollere alle kundeforhold.
            </li>
          </ol>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">
            Hvor lenge lagrer vi personopplysninger
          </h3>
          <p className="article-text">
            Vi lagrer personopplysninger om deg så lenge det er nødvendig for å
            oppnå målet det i utgangspunktet ble innhentet for, eller dersom vi
            er pålagt å lagre opplysningene. All data og informasjon vil slettes
            eller anonymiseres når det ikke lenger er nødvendig å ha dette
            lagret. Nedenfor finner du en oversikt over hvor lenge vi lagrer
            dine opplysninger:
          </p>
          <ol>
            <li>
              <span className="bold">Opplysninger om deg:</span> Hvis du har
              registrert en bruker hos oss, slettes all data koblet til kontoen
              automatisk etter 12 måneder med inaktivitet. Du vil få en varsle
              på e-post som melder fra om dette på forhånd.
            </li>
            <li>
              <span className="bold">Kjøpsinformasjon:</span> Vi lagrer aldri
              noe kjøpsinformasjon direkte hos oss, men kun detaljer vi får fra
              kjøpet gjennom Stripe. Dette inkluderer customer id, session id,
              subscription id og dato for kjøpet. Med andre ord ingen
              kortinformasjon overhode, og denne informasjonen vil forsvinne
              samtidig som annen info etter inaktivitet over 12 måneder.
            </li>
            <li>
              <span className="bold">Bruk av tjenesten:</span> Vi lagrer
              informasjon om din bruk av våre tjenester opp til 6 måneder.
            </li>
            <li>
              <span className="bold">Partnere/tredjepart:</span> Vi lagrer
              informasjon fra samarbeidspartnere så lenge du har samtykket til
              dette, eller har en aktiv konto registert hos oss. Disse
              opplysningene vil slettes ved inaktivitet etter 12 måneder.
            </li>
            <li>
              <span className="bold">Kommunikasjon: </span> Vi lagrer
              kommunikasjon med våre brukere og kunder i tre år, med mindre vi
              har behov for å lagre det i en lenger periode ved f.eks en klage
              eller et krav.
            </li>
            <li>
              <span className="bold">Profileringsopplysninger: </span> Dersom du
              har registert en bruker hos oss, slettes disse opplysningene når
              du sletter kontoen eller hvis den har vært inaktiv i 12 måneder.
              Dersom du ønsker å slette denne informasjonen tidligere, så gjør
              vi det dersom det er ønskelig.
            </li>
          </ol>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Dine rettigheter</h3>
          <p className="article-text">Du har rett til å be oss om følgende:</p>
          <ul>
            <li>
              Sende deg en kopi med alle personopplysninger vi har lagret om
              deg.
            </li>
            <li>
              Gi deg mer informasjon om hvordan vi behandler akkurat dine
              personopplysninger.
            </li>
            <li>Oppdatere personopplysningene dine.</li>
            <li>
              Slette opplysninger om deg som vi ikke lenger har grunnlag til å
              oppbevare.
            </li>
            <li>Stoppe eller begrense behandlingen av opplysninger om deg.</li>
            <li>
              Motsette deg automatiske individuelle avgjørelser, inkludert
              profilering.
            </li>
            <li>
              Sende deg opplysninger du har gitt til oss i et strukturert og
              lesbart format.
            </li>
            <li>
              Angre på eventuelle samtykker du har gitt oss vedrørende lagring
              av dine opplysninger.
            </li>
          </ul>
          <p className="article-text">
            Det finnes begrensninger i disse rettighetene. Ta kontakt med oss
            hvis du vil ha mer informasjon vedrørende dette.
            <br />
            <br />
            Dersom du mener at vi behandler eller lagrer dine personopplysninger
            i strid med personopplysningsloven eller GDPR har du rett til å
            klage inn dette til Datatilsynet. Før du eventuelt gjør dette, er
            det ønskelig at du når ut til oss slik at vi kan oppklare eventuelle
            misforståelser eller svare på dine spørsmål.
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Cookies</h3>
          <p className="article-text">
            Vi bruker cookies på våre sider for å sørge for at du får den aller
            beste brukeropplevelsen ved å sikre funksjonalitet, analysere
            trafikk og gjennomgå brukeratferd. Du kan lese mer om cookies og
            hvordan vi anvender dem ved å trykke <Link to="/cookies">her</Link>.
          </p>
        </div>
        <div className="snippet-container">
          <h3 className="article-subtitle">Nå ut til oss</h3>
          <p className="article-text">
            Hvis du har noen spørsmål angående personvernerklæringen kan du
            kontakte oss på mail ved å trykke{" "}
            <a href="mailto:kontakt@leadfind.no">her</a>.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Index;
